export default {
  inheritAttrs: false,

  data () {
    return {
      top: false,
      triggerBlur: false
    }
  },

  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    dataName: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'on'
    },

    tips: {
      type: String,
      default: null
    },

    triggerChange: {
      type: Boolean,
      default: false
    },
    topLabel: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: evt => {
          // when trigger blur event, it will also tragger input event in IE brower,
          // but we don't want to change top in blur&&input event, only need to change top in blur or input event
          if (!this.triggerBlur) {
            this.top = true
          } else {
            this.triggerBlur = false
          }
          this.$emit('input', evt.target.value)
        },
        blur: evt => {
          this.triggerBlur = true
          if (!evt.target.value) {
            this.top = false
          }
        },
        focus: evt => {
          this.top = true
        }
      }
    }
  },

  created () {
    if (this.topLabel) {
      this.top = true
    }
  }
}
